import { Divider, List, ListItem, ListItemText, Typography } from '@mui/material'
import React from 'react'

const YourRights = () => {
  return (
    <>  
        <Typography variant="h4" fontWeight="bold" gutterBottom>11. Your Rights</Typography>
        <Typography sx={{ fontSize: '1.1rem' }}>
Under applicable data protection laws, users have the right to:
        </Typography>
        <List>
            <ListItem>
                <ListItemText>
• View and access their personal data
                </ListItemText>
            </ListItem>
               <ListItem>
                <ListItemText>
• Request updates or corrections to inaccurate data
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
• Request deletion of their data via their Admin or through the in-app form
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
• Withdraw app permissions at any time (note: functionality may be limited)
                </ListItemText>
            </ListItem>
        </List>
        <Typography sx={{ fontSize: '1.1rem' }}>
            All data requests should be submitted via your Admin team, who can contact us to 
process them securely.
        </Typography>
        <Divider  sx={{ my: 2 }}/>
    </>
  )
}

export default YourRights